// src/config/constants.js
export const CACHE_TIMES = {
  ONE_MINUTE: 1000 * 60,
  FIVE_MINUTES: 1000 * 60 * 5,
  ONE_HOUR: 1000 * 60 * 60,
  ONE_DAY: 1000 * 60 * 60 * 24,
  ONE_WEEK: 1000 * 60 * 60 * 24 * 7,
};

export const PERSIST_CONFIG = {
  key: `root_${process.env.REACT_APP_COMPANY_NAME || 'default'}`, // ← ADD COMPANY
  version: 1,
};

export const QUERY_CLIENT_CONFIG = {
  defaultOptions: {
    queries: {
      gcTime: CACHE_TIMES.ONE_DAY,         // Keep cached data for 24h (instant page loads)
      staleTime: CACHE_TIMES.FIVE_MINUTES,  // Show cached data for 5min before background refetch
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 1,
    },
  },
};